import React from 'react'

import useMsgs from '@/gf/hooks/useMsgs'
import useFetchDiscounts from '../../hooks/useFetchDiscounts'
import useSession from '../../hooks/useSession'
import useSetOrganizationDiscount from '../../hooks/useSetOrganizationDiscount'

import Action from '@/gf/components/Action'
import Card from '@/gf/components/Card'
import Field from '@/gf/components/Field'
import Form from '@/gf/components/Form'
import PercentInput from '@/gf/components/inputs/Percent'

import { SetOrganizationDiscountForm } from '../../types'

type Form = Omit<SetOrganizationDiscountForm, 'storeId' | 'organizationId'>

const PricingCard = ({ orgId }: { orgId: string }) => {
  const { store } = useSession()
  const [_, msgr] = useMsgs()
  const [submitting, setSubmitting] = React.useState(false)
  const setOrganizationDiscount = useSetOrganizationDiscount()

  const discount = useFetchDiscounts({
    variables: {
      filter: JSON.stringify([
        'and',
        ['store_id_equals', store.id],
        ['organization_id_equals', orgId],
      ]),
    },
  }).data?.discounts.find((d) => d.organization.id === orgId)

  const [form, setForm] = React.useState<Form>({ percent: null })

  React.useEffect(() => {
    if (discount) setForm({ ...form, percent: discount ? discount.percent : null })
  }, [!discount])

  const onSubmit = () => {
    setSubmitting(true)

    setOrganizationDiscount({ storeId: store.id, organizationId: orgId, ...form })
      .then(() => {
        msgr.add('Discount saved.', 'positive')
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <Card title="Pricing">
      <Card.Section>
        <Form onSubmit={onSubmit} className="space-y-2">
          <Field label="Discount" desc="Discount is applied to quotes created for this account.">
            <PercentInput
              value={form.percent}
              setValue={(percent) => setForm({ ...form, percent })}
            />
          </Field>
          <Action.P type="submit" disabled={submitting}>
            {submitting ? <>Saving&hellip;</> : 'Save'}
          </Action.P>
        </Form>
      </Card.Section>
    </Card>
  )
}

export default PricingCard
